import { FloatingTextInput } from "./floating-text-input";
import { FloatingTextAreaInput } from "./floating-textarea-input";

export const SmartInput = ({ label, text, updateCallback, className, required, validatorFn, readOnly }) => {
    return text && text.length > 50 ?
        <FloatingTextAreaInput
            label={label}
            className={className}
            readOnly={readOnly}
            required={required}
            text={text}
            updateCallback={updateCallback}
            validatorFn={validatorFn}

        /> :
        <FloatingTextInput
            label={label}
            className={className}
            readOnly={readOnly}
            required={required}
            text={text}
            updateCallback={updateCallback}
            validatorFn={validatorFn}
        />
};